import { createContext } from "react";

const PageContext = createContext({
    topicFilter: [],
    roleFilter: [],
    ageFilter: [],
    setTopicFilter: (filter) => (filter),
    setRoleFilter: (filter) => (filter),
    setAgeFilter: (filter) => (filter),
    activeFilter: false,
    setActiveFilter: (activeFilter) => (activeFilter),
});

export default PageContext;
